import { IDefineCommand } from 'core-ts-types';
import * as _4 from 'lodash4';
import { FeedbackSuggestedPlanModel, IFeedbackSuggestedPlanModel } from '../models/feedback_suggested_plan_model';

angular
  .module('capability-ng-academic-planner')
  .service(
    'loadSuggestedPlanStatusCommand',
    function loadSuggestedPlanStatusCommand(
      $http: ng.IHttpService,
      log: any,
      ngFeedbackSuggestedPlanModel: FeedbackSuggestedPlanModel,
      defineCommandORM: IDefineCommand
    ) {
      return defineCommandORM('loadSuggestedPlanStatusCommand', (deferred: any, filterBy?: any) => {
        const suggestedPlanUrl = filterBy
          ? `/academicplan/suggested_plan/?status=${filterBy}`
          : `/academicplan/suggested_plan/`;
        $http
          .get(suggestedPlanUrl)
          .then((response: any) => {
            const suggestedPlan: IFeedbackSuggestedPlanModel = _4.last(_4.sortBy(response.data, ['iteration', 'id']));
            const partialPlan = _4.pick(suggestedPlan, [
              'created_ts',
              'id',
              'status',
              'committed_by',
              'from_editing',
              'previous_status',
              'edited_by',
              'edited_ts',
              'updated_ts'
            ]);
            ngFeedbackSuggestedPlanModel.write(partialPlan);
            deferred.resolve(suggestedPlan);
          })
          .catch((error: any) => {
            log.disable();
            deferred.reject(error);
            log.enable();
          });
      });
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/suggestions/components/plan_feedback/commands/load_suggested_plan_status_command.ts